import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';


//客户账户余额列表
export const findBalanceList = (params) => {
    params = parseParam(params);
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/accountBalance/getBalanceList?`+params,
        method: 'GET',
    })
};

//新增客户账户余额
export const addBalanceList = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/accountBalance/insertAccountBalance`,
        method: 'POST',
        data: data
    })
}
//通过手机号查询店铺信息
export const findMobileShop = (mobile) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/accountBalance/findShopInfo/`+mobile,
        method: 'GET'
    })
}
//通过ID查询客户账户总余额
export const findUserBalance = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/accountBalance/findAccountBalanceById?${id}`,
        method: 'GET'
    })
}
//获取阿里云token
export const findAliToken = (data) => {
    return request({
        url: `${baseUrl}/joins-oss/v1/aliyun/public/token?sessionName=${data}`,
        method: 'GET',
    })
}